import { Icon, StyleProps } from '@chakra-ui/react';

interface Properties {
  width?: number | string;
  height?: number | string;
  color?: string;
  onClick?: () => void;
  styles?: StyleProps;
}

const MenuIcon = ({
  width = '25px',
  height = '25px',
  color = '#4BB6B9',
  onClick,
  styles,
}: Properties) => {
  return (
    <Icon
      viewBox='0 0 30 25'
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      {...styles}
    >
      <path
        d='M3.42969 16.9539V15.0954H9.00514V16.9539H3.42969ZM3.42969 12.3077V10.4492H14.5806V12.3077H3.42969ZM3.42969 7.66146V5.80298H20.1561V7.66146H3.42969Z'
        fill='#4BB6B9'
      />
    </Icon>
  );
};

export default MenuIcon;
